// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rec-block[data-v-388be174] {\n  --text-opacity: 1;\n  color: #161e2e;\n  color: rgba(22, 30, 46, var(--text-opacity));\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n@media (min-width: 1024px) {\n  /* to override theme-page-content */\n.content-container.sidebar-enabled[data-v-388be174] {\n    width: 66.666667%;\n}\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
